import React, { ReactNode } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';

interface IAppointmentsScheduleProps {
  children: ReactNode;
}

const AppointmentsSchedule = ({ children }: IAppointmentsScheduleProps): JSX.Element => {
  return (
    <AppointmentsScheduleContainer>
      <AppointmentsScheduleContent>
        <RowsContainer>
          <RowIndicator />
          <RowIndicator />
          <RowIndicator />
          <RowIndicator />
          <RowIndicator />
          <RowIndicator />
          <RowIndicator />
          <RowIndicator />
          <RowIndicator />
          <RowIndicator />
          <RowIndicator />
          <RowIndicator />
          <RowIndicator />
          <RowIndicator />
          <RowIndicator />
          <RowIndicator />
          <RowIndicator />
          <RowIndicator />
          <RowIndicator />
          <RowIndicator />
          <RowIndicator />
          <RowIndicator />
          <RowIndicator />
          <RowIndicator />
        </RowsContainer>
        {children}
      </AppointmentsScheduleContent>
    </AppointmentsScheduleContainer>
  );
};

AppointmentsSchedule.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AppointmentsSchedule;

const AppointmentsScheduleContainer = styled.div`
  align-items: flex-start;
  display: flex;
  flex: 1 1 auto;
`;

const AppointmentsScheduleContent = styled.div`
  display: inline-flex;
  flex: none;
  font-size: 14px;
  min-width: 100%;
  overflow: hidden;
  position: relative;
  vertical-align: top;
  height: 100%;
`;

const RowsContainer = styled.div`
  border-top: #dadce0 1px solid;
`;

const RowIndicator = styled.div`
  height: 60px;

  &:after {
    border-bottom: #dadce0 2px dashed;
    content: '';
    margin-top: -1px;
    pointer-events: none;
    position: absolute;
    width: 100%;
    z-index: 3;
  }
`;
